import axiosInstance from "@/api/axiosInstance";
import type { RevenueParams, GetRevenueResponse, RevenueItem } from "@/types/revenue.type";

export const getRevenueMonthly = async (
    params: RevenueParams
): Promise<RevenueItem[]> => {
    try {
        const response = await axiosInstance.get<GetRevenueResponse>(
            "/trans/pendapatan-bulanan",
            {
                params,
            }
        );

        if (response.data.success) {
            return response.data.data;
        }

        throw new Error("Gagal mengambil data pendapatan");
    } catch (error) {
        console.error("getRevenueMonthly error:", error);
        throw error;
    }
};
